<template>
<!-- eslint-disable -->
<!-- Icon made by Freepik from www.flaticon.com -->
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 490.667 490.667" style="enable-background:new 0 0 490.667 490.667;" xml:space="preserve">
<g>
	<g>
		<path d="M394.667,0c-55.424,0-85.333,109.909-85.333,213.333s29.909,213.333,85.333,213.333
			c55.424,0,85.333-109.909,85.333-213.333S450.091,0,394.667,0z M394.667,405.333c-30.272,0-64-78.848-64-192s33.728-192,64-192
			c30.272,0,64,78.848,64,192S424.939,405.333,394.667,405.333z"/>
	</g>
</g>
<g>
	<g>
		<path d="M384,149.333c-5.888,0-10.667,4.779-10.667,10.667s4.779,10.667,10.667,10.667c17.643,0,32,19.136,32,42.667
			S401.643,256,384,256c-5.888,0-10.667,4.779-10.667,10.667s4.779,10.667,10.667,10.667c29.419,0,53.333-28.715,53.333-64
			S413.419,149.333,384,149.333z"/>
	</g>
</g>
<g>
	<g>
		<path d="M330.667,213.333c0-71.403,14.016-136.981,36.608-171.179c2.837-4.267,2.219-9.941-1.472-13.525
			c-3.691-3.584-9.429-4.011-13.568-1.067L209.941,128H96c-47.061,0-85.333,38.272-85.333,85.333S48.939,298.667,96,298.667h113.941
			l142.293,100.437c1.856,1.301,3.989,1.941,6.144,1.941c2.688,0,5.376-1.024,7.424-3.008c3.691-3.563,4.309-9.237,1.472-13.525
			C344.683,350.315,330.667,284.736,330.667,213.333z M219.477,279.275c-1.792-1.259-3.925-1.941-6.144-1.941H96
			c-35.285,0-64-28.715-64-64s28.715-64,64-64h117.333c2.219,0,4.352-0.683,6.144-1.963l111.68-78.827
			c-13.803,38.635-21.824,90.347-21.824,144.789s8.021,106.155,21.824,144.768L219.477,279.275z"/>
	</g>
</g>
<g>
	<g>
		<path d="M204.907,384.555l18.901-94.464c0.619-3.136-0.192-6.379-2.219-8.853s-5.077-3.904-8.256-3.904
			c-39.381,0-53.333-34.475-53.333-64s13.952-64,53.333-64c5.888,0,10.667-4.779,10.667-10.667S219.221,128,213.333,128
			c-44.672,0-74.667,34.283-74.667,85.333c0,45.995,24.363,78.379,61.845,84.331l-16.533,82.688
			c-2.219,11.136,1.237,22.592,9.323,30.677c6.037,6.059,9.365,14.08,9.365,22.635v7.317c0,8.555-3.328,16.597-9.365,22.656
			l-2.645,2.645l-37.739-25.152c-8.917-5.952-14.251-15.915-14.251-26.624v-83.84c0-2.837-1.131-5.547-3.136-7.552l-42.667-42.667
			c-4.16-4.16-10.923-4.16-15.083,0s-4.16,10.923,0,15.083l39.552,39.552v79.424c0,17.877,8.875,34.453,23.744,44.373l45.013,29.995
			c1.813,1.216,3.861,1.792,5.909,1.792c2.752,0,5.483-1.067,7.552-3.115l8.832-8.832C218.453,468.651,224,455.253,224,441.003
			v-7.317c0-14.251-5.547-27.648-15.637-37.76C205.355,392.939,204.075,388.672,204.907,384.555z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>

<script>
export default {
  name: 'PromotionsIcon'
};
</script>
